import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackClickCallButton } from '../../actions/userCard/tracking';
import { UserCardActions } from '../../components/UserCardMobile/UserCardActions';
import { UserCardCallButton } from '../../components/UserCardMobile/UserCardCallButton';
import { UserCardProfileLink } from '../../components/UserCardMobile/UserCardProfileLink';
import { useCompanionData } from '../../hooks';
import { currentChatOpponentIdSelector, currentOpenChatSelector, customActionsSelector } from '../../selectors';
import { ECustomAction } from '../../types/customActions';
import { UserCardMenuActionsContainer } from '../UserCardMenuActionsContainer';
import { UserCardMobileCustomActionButtonContainer } from '../UserCardMobileCustomActionButtonContainer';

const COUNT_BUTTONS_USERCARD = 3;

export const UserCardMobileActionsContainer = () => {
  const currentChat = useSelector(currentOpenChatSelector);
  const customActions = useSelector(customActionsSelector);
  const opponentId = useSelector(currentChatOpponentIdSelector);

  const { companionId, formatPhone, profileLink } = useCompanionData(currentChat?.chatId);

  const subscribeActionButton = React.useMemo(() => {
    const button = customActions
      ? customActions.find(({ action }) => action === ECustomAction.Unsubscribe || action === ECustomAction.Subscribe)
      : undefined;

    return button || null;
  }, [customActions]);

  const customActionsWithoutSubscribe = React.useMemo(() => {
    const actions = customActions
      ? customActions.filter(({ action }) => action !== ECustomAction.Unsubscribe && action !== ECustomAction.Subscribe)
      : [];

    return actions || [];
  }, [customActions]);

  if (!currentChat?.chatId || currentChat?.chatId === 'blob') {
    return null;
  }

  const handleClickCallButton = () => {
    trackClickCallButton(currentChat, companionId, opponentId);
  };

  const actions = [];

  if (subscribeActionButton) {
    actions.push(
      <UserCardMobileCustomActionButtonContainer button={subscribeActionButton} chatId={currentChat.chatId} />,
    );
  }

  if (formatPhone) {
    actions.push(<UserCardCallButton phone={`tel:${formatPhone}`} onClick={handleClickCallButton} />);
  }

  if (profileLink) {
    actions.push(<UserCardProfileLink userProfileUrl={profileLink} />);
  }

  const actionsLength = actions.length;

  if (actionsLength < 4 && customActions) {
    // максимум на карточке 3 кнопки с учетом телефона и ссылки на профиль
    customActionsWithoutSubscribe.slice(0, COUNT_BUTTONS_USERCARD - actionsLength).forEach(button => {
      actions.push(<UserCardMobileCustomActionButtonContainer button={button} chatId={currentChat.chatId} />);
    });
  }

  const menu = (
    <UserCardMenuActionsContainer
      customActions={customActionsWithoutSubscribe.slice(COUNT_BUTTONS_USERCARD - actionsLength)}
    />
  );

  return <UserCardActions actions={actions} menu={menu} />;
};
